if (!customElements.get("special-order-dialog")) {
  customElements.define(
    "special-order-dialog",
    class SpecialOrderDialog extends HTMLElement {
      constructor() {
        super();

        this.dialog = this.querySelector("dialog");
        this.productName = this.querySelector("[data-special-order-product]");
        this.leadTime = this.querySelector("[data-special-order-lead-time]");
        this.confirmButton = this.querySelector("[data-special-order-confirm]");
        this.closeButtons = this.querySelectorAll("[data-special-order-close]");

        this.confirm = this.confirm.bind(this);
        this.close = this.close.bind(this);
        this.closeFromBackdrop = this.closeFromBackdrop.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
      }

      connectedCallback() {
        this.confirmButton?.addEventListener("click", this.confirm);
        this.closeButtons.forEach((button) =>
          button.addEventListener("click", this.close),
        );
        this.dialog?.addEventListener("click", this.closeFromBackdrop);
        this.dialog?.addEventListener("close", this.onDialogClose);
      }

      disconnectedCallback() {
        this.confirmButton?.removeEventListener("click", this.confirm);
        this.closeButtons.forEach((button) =>
          button.removeEventListener("click", this.close),
        );
        this.dialog?.removeEventListener("click", this.closeFromBackdrop);
        this.dialog?.removeEventListener("close", this.onDialogClose);
      }

      open(productForm) {
        if (!this.dialog || this.dialog.open) return;

        this.productForm = productForm;
        this.returnFocusTo = document.activeElement;

        const title = productForm.dataset.specialOrderProductTitle?.trim();
        this.productName.textContent = title || "";
        this.productName.hidden = !title;

        const leadTime = productForm.dataset.specialOrderLeadTime?.trim();
        if (leadTime) this.leadTime.textContent = leadTime;

        document.body.classList.add("special-order-dialog-open");
        this.dialog.returnValue = "";
        this.dialog.showModal();
        this.confirmButton?.focus();
      }

      confirm() {
        if (!this.productForm) return;

        const productForm = this.productForm;
        productForm.dataset.specialOrderConfirmed = "true";
        this.dialog.close("confirmed");
        productForm.requestSubmit();
      }

      close() {
        this.dialog?.close("cancelled");
      }

      closeFromBackdrop(event) {
        if (event.target !== this.dialog) return;

        const bounds = this.dialog.getBoundingClientRect();
        const clickedInside =
          event.clientX >= bounds.left &&
          event.clientX <= bounds.right &&
          event.clientY >= bounds.top &&
          event.clientY <= bounds.bottom;

        if (!clickedInside) this.close();
      }

      onDialogClose() {
        document.body.classList.remove("special-order-dialog-open");

        if (this.dialog.returnValue !== "confirmed") {
          this.returnFocusTo?.focus();
        }

        this.productForm = null;
        this.returnFocusTo = null;
      }
    },
  );
}
